export function ageVerificationInit() {

    let oldEnough = localStorage.getItem('oldEnough');

    if (!oldEnough) {
        $('.age-verification').addClass('show');
    }

    $('#age-verification-no').on('click', function() {
        $('.age-verification .ask').css('display', 'none');
        $('.age-verification .too-young').css('display', 'block');
    });

    $('#age-verification-yes').on('click', function() {
        $('.age-verification').removeClass('show');
        localStorage.setItem('oldEnough', true);
    });
}